import $ from 'jquery';

$('#UploadMeasurementForm').on('submit', e => {
  const $form = $(e.target);
  $form.parent().toggleClass('uploading-measurements');
  $form.find('button[type="submit"]').attr('disabled', 'disabled');
});


// WEBPACK FOOTER //
// ./App/containers/upload-measurement.js